document.addEventListener('DOMContentLoaded', () => {
  initNegativeProductCursor();

  // Initialize Lenis for Smooth Scrolling
  const lenis = new Lenis({
    duration: 1.1,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    direction: 'vertical',
    gestureDirection: 'vertical',
    smooth: true,
    mouseMultiplier: 1,
    smoothTouch: false,
    touchMultiplier: 2,
    infinite: false,
  });

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }

  // Integrate Lenis with GSAP ScrollTrigger
  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);

    // Update ScrollTrigger on Lenis scroll
    lenis.on('scroll', ScrollTrigger.update);

    gsap.ticker.add((time) => {
      lenis.raf(time * 1000);
    });

    gsap.ticker.lagSmoothing(0, 0);

    // Re-usable GSAP animations

    // Mount Text Reveal
    const revealText = document.querySelectorAll('.animate-text-mount');
    revealText.forEach((el) => {
      gsap.fromTo(el,
        { y: 50, opacity: 0 },
        { y: 0, opacity: 1, duration: 1, ease: "expo.out" }
      );
    });

    // 1. Text reveal on scroll
    const revealElements = document.querySelectorAll('.animate-text-reveal');
    revealElements.forEach((el) => {
      // Split text into words (simple split for demo purpose, or just animate the whole block up)
      // For proper word splitting, SplitType is better, but building without it:
      gsap.fromTo(el,
        { y: 50, opacity: 0 },
        {
          scrollTrigger: {
            trigger: el,
            start: "top 85%",
            toggleActions: "play none none none"
          },
          y: 0,
          opacity: 1,
          duration: 1,
          ease: "expo.out"
        }
      );
    });

    // 2. Parallax images — target the whole .featured-item so image + title move together
    const parallaxItems = document.querySelectorAll('.featured-item.animate-parallax');
    parallaxItems.forEach((item) => {
      gsap.to(item, {
        yPercent: 10,
        ease: "",
        scrollTrigger: {
          trigger: item.parentElement,
          start: "top bottom",
          end: "bottom top",
          scrub: true
        }
      });
    });

    // Parallax for non-featured elements (hero, wall-art, etc.) — image only is fine here
    const parallaxImages = document.querySelectorAll('.animate-parallax:not(.featured-item) img');
    parallaxImages.forEach((img) => {
      gsap.to(img, {
        yPercent: 10,
        ease: "",
        scrollTrigger: {
          trigger: img.parentElement,
          start: "top bottom",
          end: "bottom top",
          scrub: true
        }
      });
    });

    // 3. One-way scroll-in for featured images
    const featuredImages = document.querySelectorAll('.animate-featured-image');
    featuredImages.forEach((img) => {
      gsap.fromTo(img,
        { y: 150, opacity: 0 },
        {
          scrollTrigger: {
            trigger: img,
            start: "top 95%", // Triggers slightly before it enters fully
            toggleActions: "play none none none" // Play once, don't reverse!
          },
          y: 0,
          opacity: 1,
          duration: 1.2,
          ease: "expo.out"
        }
      );
    });
  } else {
    requestAnimationFrame(raf);
  }

  // Smooth Scroll Anchor Links using Lenis
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      const target = this.getAttribute('href');
      if (target && target !== '#') {
        lenis.scrollTo(target, { offset: -50, duration: 1.5 });
      }
    });
  });
});

function initNegativeProductCursor() {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  const cursorTargets = [
    '.small-item-card__media-link',
    '.shirt-image-wrapper',
    '.print-item',
    '.product-page__image-wrapper',
  ].join(',');

  document.querySelectorAll(cursorTargets).forEach((target) => {
    target.setAttribute('data-negative-cursor', '');
  });

  const cursor = document.createElement('div');
  cursor.className = 'product-negative-cursor';
  cursor.setAttribute('aria-hidden', 'true');
  document.body.appendChild(cursor);

  let activeTarget = null;
  let x = 0;
  let y = 0;
  let cursorX = 0;
  let cursorY = 0;
  let rafId = null;

  function render() {
    cursorX += (x - cursorX) * 0.28;
    cursorY += (y - cursorY) * 0.28;
    cursor.style.left = cursorX + 'px';
    cursor.style.top = cursorY + 'px';
    rafId = activeTarget ? requestAnimationFrame(render) : null;
  }

  function activate(target, event) {
    activeTarget = target;
    x = event.clientX;
    y = event.clientY;
    cursorX = x;
    cursorY = y;
    cursor.classList.add('is-active');
    if (!rafId) rafId = requestAnimationFrame(render);
  }

  function deactivate() {
    activeTarget = null;
    cursor.classList.remove('is-active');
  }

  document.addEventListener('pointerover', (event) => {
    const target = event.target.closest(cursorTargets);
    if (!target) return;
    activate(target, event);
  });

  document.addEventListener('pointermove', (event) => {
    if (!activeTarget) return;
    x = event.clientX;
    y = event.clientY;
  });

  document.addEventListener('pointerout', (event) => {
    if (!activeTarget) return;
    if (event.relatedTarget && activeTarget.contains(event.relatedTarget)) return;
    deactivate();
  });

  document.addEventListener('pointerdown', () => {
    if (!activeTarget) return;
    cursor.style.transform = 'translate3d(-50%, -50%, 0) scale(0.82)';
  });

  document.addEventListener('pointerup', () => {
    cursor.style.transform = '';
  });
}
